import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import Grid from '@material-ui/core/Grid'
import React, { PropsWithChildren } from 'react'
import { CreditUnionIcon, IconCodeType } from '../icon/CreditUnionIcon'
import { LinkProps } from '../link/link'
import {
  StyledCardContainer,
  StyledCardIconContainer,
  StyledCardList,
  StyledCardWrapper,
  StyledQuickLink,
  StyledTitleCheveron,
  StyledTitleText,
  StyledInnerLinkWrapper
} from './styledQuickLinksCard'

export type QuickLinksCardProps =  React.ComponentProps<typeof StyledCardContainer> & Pick<LinkProps, 'href'> & {
  title: string
  iconCode?: IconCodeType
  variant?: 'legacy' | 'line' | 'monotone' | 'dualtone'
  href?: string
  target?: string
}

export const QuickLinksCard: React.FC<PropsWithChildren<QuickLinksCardProps>> = ({ title, variant, iconCode, href, target, children, item=true, xs=12, sm=12, ...props }) => {
  return (
    <StyledCardContainer item={item} xs={xs} sm={sm} {...props}>
      <StyledCardWrapper container justifyContent="flex-start" alignItems="center">
        <StyledInnerLinkWrapper aria-label={title} href={href ?? '#'} rel={target === '_blank' ? 'nooppener noreferrer' : ''} target={target ?? '_self'}>
          <StyledCardIconContainer item>
            <StyledTitleText aria-label={title} href={href ?? '#'} rel={target === '_blank' ? 'nooppener noreferrer' : ''} target={target ?? '_self'}>
              <CreditUnionIcon alt={`${iconCode} icon`} width={36} height={36} iconCode={iconCode as IconCodeType} variant={variant === 'legacy' ? 'monotone' : variant} />
            </StyledTitleText>
          </StyledCardIconContainer>
          <StyledQuickLink container direction="row" justifyContent="flex-start" alignItems="center" wrap="nowrap">
            <StyledTitleText aria-label={title} href={href ?? '#'} rel={target === '_blank' ? 'nooppener noreferrer' : ''} target={target ?? '_self'}>{ title }</StyledTitleText>
            <StyledTitleCheveron icon={faChevronRight}/>
          </StyledQuickLink>
        </StyledInnerLinkWrapper>
      </StyledCardWrapper>
      <Grid container>
        <StyledCardList>
          {children}
        </StyledCardList>
      </Grid>
    </StyledCardContainer>
  )
}